<template>
  <div class="plannedBudget">
    <div class="plannedBudget_titleArea">
      <h3 class="title">计划日预算</h3>
    </div>
    <div class="plannedBudget_main">
      <div class="main_input">
        <el-input
          v-model="input"
          placeholder="请输入内容"
          type="number"
          @input="myInput"
        />
        <span class="input_text">元/天</span>
      </div>
      <span class="main_tips">非必填，用于控制当前计划总共日消耗上限，每日预算 50 元 ~ 40,000,000 元/天。</span>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    daily_budget: {},
    campaign: {
      type: Object
    }
  },
  data() {
    return {
      input: ''
    }
  },
  created() {
    this.input = this.campaign.day_budget / 100
  },
  methods: {
    myInput(e) {
      this.$emit('setDailyBudget', Number(e) * 100)
    }
  }
}
</script>

<style scoped lang="less">
.plannedBudget {
  width: 100%;
  box-shadow: 0 0 0 1px hsla(0, 0%, 87%, 0.5), 0 3px 6px 0 rgba(0, 0, 0, 0.04);
  background-color: #fff;
  border-radius: 5px;
  padding-bottom: 25px;
  margin-top: 10px;
  .plannedBudget_titleArea {
    padding: 16px 16px 20px 24px;
    margin-bottom: 8px;
    .title {
      font-size: 14px;
      font-weight: 600;
      color: #1f1f1f;
    }
  }

  .plannedBudget_main {
    margin: 20px;
    .main_input {
      width: 150px;
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      .input_text {
        display: inline-block;
        margin-left: 10px;
        white-space: nowrap;
      }
    }
    .main_tips {
    }
  }
}
</style>
